import { axiosInstance } from './index';

import BackendConstants from '../common/backendConstants';

export const exportApplicationData = async (params) => {
    return await axiosInstance.post(BackendConstants.exportAppointmentData.replace(':resource', 'appointments'), { params: params });
};